//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalOrganizationStore = hookstate({
    OrgTree: undefined,
    IsActive: true
});

export default globalOrganizationStore;